import React from "react";
import { usePagination, DOTS } from "../customHooks/usePagination";
const PaginationComponent = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange?.length - 1];
  return (
    <div className="SB-pagination">
      <div className="SB-pagination-container">
        <ul>
          <li key="prev">
            <a
              className={`SB-pagination-control SB-pagnination-left ${
                currentPage === 1 ? "SB-disabled" : ""
              }`}
              onClick={onPrevious}
            >
              <div className="SB-iconSVG">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 32 32"
                  style={{ enableBackground: "new 0 0 32 32" }}
                  xmlSpace="preserve"
                >
                  <polygon points="22.2,32 6.6,16.4 6.6,15.6 22.2,0 25.4,3.1 12.7,16 25.4,28.7 "></polygon>
                </svg>
              </div>
            </a>
          </li>
          {paginationRange.map((pageNumber, index) => {
            if (pageNumber === DOTS) {
              return <li key={`dots-${index}`} className="pagination-item dots">&#8230;</li>;
            }
            return (
              <li key={pageNumber} onClick={() => onPageChange(pageNumber)}>
                <a
                  className={`SB-pagination-item ${
                    pageNumber === currentPage ? "active" : ""
                  }`}
                >
                  {pageNumber}
                </a>
              </li>
            );
          })}
          <li key="next">
            <a
              className={`SB-pagination-control SB-pagnination-right ${
                currentPage === lastPage ? "SB-disabled" : ""
              } `}
              onClick={onNext}
            >
              <div className="SB-iconSVG">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 32 32"
                  style={{ enableBackground: "new 0 0 32 32" }}
                  xmlSpace="preserve"
                >
                  <polygon points="9.8,0 25.4,15.6 25.4,16.4 9.8,32 6.6,28.8 19.3,16 6.6,3.2 "></polygon>
                </svg>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PaginationComponent;
